import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import { measurementsState } from '@state';
import { useMount } from 'ahooks';
import { loadStateFromURL } from '../loadableStateUtils';
import { getApplicationTags } from '@utils';
import ShareableLink from './ShareableLink';
import SaveToAccount from './SaveToAccount';

const RoomNameInput = ({ product }) => {
  let ctx = window.theme_app;
  const [mainProdApplication, setMainProdApplication] = useState();
  const [name, setName] = useRecoilState(measurementsState('roomName'));

  useMount(() => {
    let tags = getApplicationTags(product.tags, 'application');
    if (tags) {
      setMainProdApplication(tags[0]);
    }
    loadStateFromURL({ stateKey: 'Room Name', setter: setName, defaultValue: null });
  });

  return (
    <>
      <div className="sizeInput roomName">
        <label htmlFor="roomName" className="screen-reader-text">
          Room Name
        </label>
        <input
          type="text"
          name="roomName"
          id="roomName"
          placeholder="Room Location label"
          value={name}
          onChange={(ev) => setName(ev.target.value)}
          required
        />
        <small>Used for identification purposes only.</small>
      </div>
      <hr />
      {mainProdApplication === 'Drawer Organizers' && (
        <div className="Product__sharing">
          {ctx.getState().customer_email ? (
            <SaveToAccount customer={ctx.getState().customer_email} product={product}></SaveToAccount>
          ) : (
            <a href="/account" className="button" data-style="dark text">
              Login to Save Configuration
            </a>
          )}
          <ShareableLink></ShareableLink>
        </div>
      )}
    </>
  );
};

export default RoomNameInput;
